export default __webpack_public_path__ + "static/media/filter_icon_playground.2531518d.svg";